import SDError from './SDError';

export default class NoResponseError extends SDError {
  type = 'warning';
}



// WEBPACK FOOTER //
// ./src/model/NoResponseError.js